// extracted by mini-css-extract-plugin
export default {"smTd":"Inquiries_smTd__EUaQ2","priceTd":"Inquiries_priceTd__lV5ar","statusLabel":"Inquiries_statusLabel__71DsT"};